import React, { useMemo } from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const MultiSelectFilter = ({ filter, onFilterChange }) => {
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    const selectedValues = newValue.map(item => item.value);
    // If no values selected, pass empty array instead of undefined
    onFilterChange(filter.id, selectedValues.length > 0 ? selectedValues : []);
  };

  const selectedOptions = useMemo(() => {
    return filter.options?.filter(option => 
      filter.value && Array.isArray(filter.value) && filter.value.includes(option.value)
    ) || [];
  }, [filter.options, filter.value]);



  return (
    <Autocomplete
      multiple
      options={filter.options || []}
      value={selectedOptions}
      onChange={handleChange}
      getOptionLabel={(option) => {
        if (typeof option === 'string') return option;
        if (option && typeof option === 'object' && option.label) return option.label;
        return '';
      }}
      getOptionKey={(option) => {
        if (typeof option === 'string') return option;
        return option && option.value != null ? option.value : '';
      }}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        if (typeof option === 'object' && typeof value === 'object') {
          return option.value === value.value;
        }
        return option === value;
      }}
      filterOptions={(options, { inputValue }) => {
        if (!inputValue) return options;
        return options.filter(option => {
          if (typeof option === 'object' && option.label) {
            return option.label.toLowerCase().includes(inputValue.toLowerCase());
          }
          return false;
        });
      }}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => {
          const { key, ...chipProps } = getTagProps({ index });
          // Kritik: `{...chipProps}` icinde `onClick: undefined` gelebilir.
          // Bunu bir noop'la EZMELIYIZ (spread SONRASI onClick tanimlanmasi).
          // Eskiden onClick spread'ten ONCE veriliyordu → chipProps.onClick
          // undefined noop'u ezerdi → chip'e tiklandiginda
          // "onClick is not a function" hatasi firlardi.
          return (
            <Chip
              key={key}
              variant="outlined"
              label={option.label}
              size="small"
              sx={{
                maxWidth: 120,
                '& .MuiChip-label': {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
              }}
              {...chipProps}
              onClick={undefined}
            />
          );
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={filter.label}
          size="small"
          sx={{ 
            minWidth: 200,
            '& .MuiAutocomplete-tag': {
              margin: '2px',
            },
          }}
        />
      )}
      sx={{
        '& .MuiAutocomplete-inputRoot': {
          padding: '4px 8px',
        },
      }}
    />
  );
};

export default MultiSelectFilter;
